import { render, staticRenderFns } from "./SubFactorExcel.vue?vue&type=template&id=893c1f4a&scoped=true&"
import script from "./SubFactorExcel.vue?vue&type=script&lang=js&"
export * from "./SubFactorExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893c1f4a",
  null
  
)

export default component.exports